import * as THREE from 'three'
import Experience from './Experience.js'
import gsap from 'gsap'

export default class Overlay {
    constructor() {
        this.experience = new Experience()

        this.setOverlay()
        this.setLoadingManager()
        this.setButton()
    }

    setOverlay() {
        this.geometry = new THREE.PlaneGeometry(2, 2)
        this.material = new THREE.ShaderMaterial({
            transparent: true,
            uniforms: {
                uAlpha: { value: 1 },
            },
            vertexShader: `
        void main() {
          gl_Position = vec4(position, 1.0);
        }
      `,
            fragmentShader: `
        uniform float uAlpha;
        void main() {
          gl_FragColor = vec4(0.0, 0.0, 0.0, uAlpha);
        }
      `,
        })

        this.mesh = new THREE.Mesh(this.geometry, this.material)
        this.experience.scene.add(this.mesh)
    }

    setButton() {
        const creditsButton = document.querySelector('#creditsBtn')
        const closeButton = document.querySelector('#closeBtn')
        const creditsList = document.querySelector('#creditsList')

        if (!creditsButton) {
            console.warn('[Overlay] Button #creditsBtn not found in DOM.')
            return
        }

        creditsButton.addEventListener('click', () => {
            creditsList.classList.add('visible')
            creditsButton.classList.remove('visible')
        })

        if (closeButton) {
            closeButton.addEventListener('click', () => {
                creditsList.classList.remove('visible')
                creditsButton.classList.add('visible')
            })
        }
    }

    setLoadingManager() {
        const loadingBarElement = document.querySelector('.loading-bar')
        const creditsButton = document.querySelector('#creditsBtn')

        this.loadingManager = new THREE.LoadingManager(
            () => {
                gsap.delayedCall(0.5, () => {
                    gsap.to(this.material.uniforms.uAlpha, {
                        value: 0, duration: 2, ease: 'power2.inOut'
                    })
                    if (loadingBarElement) {
                        loadingBarElement.style.transform = ``
                        loadingBarElement.classList.add('ended')
                    }
                    if (creditsButton) {
                        creditsButton.classList.add('visible')
                    }
                })
            },
            (itemUrl, itemsLoaded, itemsTotal) => {
                const progressRatio = itemsLoaded / itemsTotal
                if (loadingBarElement) {
                    loadingBarElement.style.transform = `scaleX(${progressRatio})`
                }
            }
        )
    }
}